export default {
  install: (app, pluginConfig) => {
    function trackEvent(name, value) {
      app.config.globalProperties.$matomo.trackEvent(name, value);
      if (window.fbq) {
        window.fbq('trackCustom', name, { value });
      }
    }

    app.config.globalProperties.$track = {
      conversion() {
        trackEvent('conversion', 'clicked');
      },
      newsletterSignup() {
        trackEvent('newsletter', 'submission');
      },
      clickedInfoEmail() {
        trackEvent('email', 'info');
      },
      clickedDemoEmail() {
        trackEvent('email', 'demo');
      },
      supportPage(link) {
        trackEvent('supportclick', link.support_link_select);
      }
    };
  }
};
